"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var nanoid_1 = require("nanoid");
var __1 = require("../");
exports.FormField = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var _c;
    var children = _a.children, className = _a.className, control = _a.control, controlRef = _a.controlRef, controlClassName = _a.controlClassName, description = _a.description, disabled = _a.disabled, _d = _a.el, el = _d === void 0 ? 'div' : _d, error = _a.error, label = _a.label, labelProps = _a.labelProps, required = _a.required, size = _a.size, toggleboxControl = _a.toggleboxControl, width = _a.width, props = __rest(_a, ["children", "className", "control", "controlRef", "controlClassName", "description", "disabled", "el", "error", "label", "labelProps", "required", "size", "toggleboxControl", "width"]);
    var controlType = control !== undefined
        ? (_c = control.name) !== null && _c !== void 0 ? _c : control.displayName : 'control';
    var labelFor = props.id || "formfield_id_" + nanoid_1.customAlphabet(lettersOnly, 8)();
    var _e = react_1.useState({
        labelFor: labelFor,
        setFormFieldContext: function () { },
    }), context = _e[0], setContext = _e[1];
    var setFormFieldContext = function (newContext) {
        return setContext(__assign(__assign({}, context), newContext));
    };
    var handleLabelClick = function () {
        var _a;
        var inputNode = (_a = context === null || context === void 0 ? void 0 : context.inputRef) === null || _a === void 0 ? void 0 : _a.current;
        if (['Select', 'Dropdown'].includes(controlType)) {
            inputNode === null || inputNode === void 0 ? void 0 : inputNode.focus();
            return;
        }
        inputNode === null || inputNode === void 0 ? void 0 : inputNode.click();
    };
    var getLabel = function () {
        if (label === undefined || label === '')
            return false;
        var labelClassName = (labelProps === null || labelProps === void 0 ? void 0 : labelProps.className) ? labelProps.className
            : null;
        var labelClasses = classnames_1.default(labelClassName, 'FormField__label');
        return (react_1.default.createElement(__1.Label, __assign({ disabled: disabled, required: required }, labelProps, { className: labelClasses }), label));
    };
    var getFieldDescription = function () {
        if (description === undefined || description === '')
            return false;
        return react_1.default.createElement("div", { className: "FormField__description" }, description);
    };
    var getErrorText = function () {
        if (error === undefined)
            return false;
        return react_1.default.createElement("div", { className: "FormField__errorText" }, error);
    };
    var getControl = function () {
        var controlProps = __assign(__assign({ children: children,
            disabled: disabled,
            required: required,
            size: size, className: controlClassName }, props), (control !== __1.ToggleSwitch &&
            control !== __1.ButtonToggle &&
            toggleboxControl !== 'toggleSwitch' &&
            control !== __1.Button
            ? { error: !!error }
            : {}));
        // Togglebox
        if (control === __1.Togglebox) {
            return (react_1.default.createElement(__1.Togglebox, __assign({ label: label, control: toggleboxControl }, controlProps)));
        }
        // Checkbox, Radio, ToggleSwitch
        if (control === __1.Checkbox ||
            control === __1.Radio ||
            control === __1.ToggleSwitch) {
            return react_1.default.createElement(control, __assign(__assign({}, controlProps), { label: label,
                labelProps: labelProps,
                required: required,
                ref: ref }));
        }
        var createControl = control
            ? react_1.default.createElement(control, __assign(__assign({}, controlProps), { ref: ref }))
            : children;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("label", { className: "Field__html-label", htmlFor: context.labelFor, onClick: handleLabelClick }, getLabel()),
            react_1.default.createElement(__1.FormFieldContext.Provider, { value: __assign(__assign({}, context), { setFormFieldContext: setFormFieldContext }) }, createControl)));
    };
    var FormFieldProps = { children: children, disabled: disabled };
    var FormFieldClasses = classnames_1.default('FormField', className, (_b = {
            'FormField--disabled': disabled,
            'FormField--error': error
        },
        _b["FormField--" + controlType] = control,
        _b['FormField--small'] = size === 'small',
        _b['FormField--large'] = size === 'large',
        _b['FormField--fitted'] = label === undefined || label === '',
        _b["FormField--width-" + width] = width,
        _b));
    var FormFieldElement = el;
    return (react_1.default.createElement(FormFieldElement, __assign({ className: FormFieldClasses }, FormFieldProps),
        react_1.default.createElement("div", { className: "FormField__wrapper" },
            getControl(),
            react_1.default.createElement("div", { className: "FormField__helpers" },
                getErrorText(),
                getFieldDescription()))));
});
var lettersOnly = 'abcdefghijklmnopqrstuvwxyz';
//# sourceMappingURL=FormField.js.map